function topMap() {
  const regions = document.querySelectorAll(".p-home__pref-region");

  if (!regions.length) return;

  let initialized = false;

  function closeAllRegions() {
    regions.forEach((region) => {
      region.classList.remove("is-open");
    });
  }

  function init() {
    // 1024px以上では何もしない
    if (window.innerWidth > 1023 || initialized) return;

    regions.forEach((region) => {
      const openBtn = region.querySelector(".p-home__pref-region-btn");
      const backBtn = region.querySelector(".p-home__pref-back");

      if (openBtn) {
        openBtn.addEventListener("click", () => {
          closeAllRegions();
          region.classList.add("is-open");
        });
      }

      if (backBtn) {
        backBtn.addEventListener("click", () => {
          region.classList.remove("is-open");
        });
      }
    });

    initialized = true;
  }

  // 初回
  init();

  // 1024px以上 → 1023px以下になった時にも初期化
  window.addEventListener("resize", () => {
    if (window.innerWidth <= 1023) {
      init();
    }
  });
}

export { topMap };
